import { useMemo } from 'react';

interface IProps {
  height: number;
  lastPointY: number;
  labelHeight?: number;
}

/** The hook is to get the current height of the y axis The height can change depending on data */
const useMiddleY = ({ height, lastPointY, labelHeight }: IProps): number => {
  const computedHeight = useMemo(() => height - lastPointY, [
    height,
    lastPointY,
  ]);

  const heightHorizontalLine = labelHeight ? labelHeight / 2 : 25;
  const calculatedMiddleY = useMemo(
    () => lastPointY + computedHeight / 2 + heightHorizontalLine,
    [computedHeight, heightHorizontalLine, lastPointY]
  );
  return calculatedMiddleY;
};

export default useMiddleY;
